module.exports = __webpack_public_path__ + "img/ganhuo-logo.cf9faf5f.png";